import store from 'utils/store/withMiddleware'
import addStyleToHead from '@hc-frontend/shared-assets/src/js/utils/dom/addStyleToHead'
import { isValidDate } from '@hc-frontend/utils'

interface BannerProps {
  highlightYear: string
  nricStartDate: Date
  clicStartDate: Date
  planTypes: string[]
}

function forumBanner({
  highlightYear,
  nricStartDate,
  clicStartDate,
  planTypes = []
}: BannerProps) {
  if (
    !highlightYear ||
    !nricStartDate ||
    !clicStartDate ||
    !isValidDate(nricStartDate) ||
    !isValidDate(clicStartDate)
  ) {
    return
  }

  const state = store.getState()

  const { hcStorage } = state

  const croPlan = hcStorage.pivotPlan?.planType

  if (
    croPlan &&
    hcStorage.location.state_acronym.indexOf('IN') > -1 &&
    planTypes.includes(croPlan)
  ) {
    const nricMonth = nricStartDate.toLocaleString('default', { month: 'long' })
    const nricYear = nricStartDate.getFullYear()
    const nricDay = nricStartDate.getUTCDate()

    const clicMonth = clicStartDate.toLocaleString('default', { month: 'long' })
    const clicYear = clicStartDate.getFullYear()
    const clicDay = clicStartDate.getUTCDate()

    const urlCompanion =
      'https://healthcare.zoom.us/webinar/register/WN_rr0dZ6JoQGeroSsppvWnUQ'
    const urlNorth =
      'https://healthcare.zoom.us/webinar/register/WN_MbSNDBxASh29r1Op_vWcYw'

    const cro_modal = `
      <div class="modal ${croPlan}" id="cro_forum" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p class="text-center cro-info cro-info--companion">The Companion Life Insurance Company announces a public forum review of the ${highlightYear} Short Term Medical Pivot Health Plan portfolio on ${clicMonth} ${clicDay}, ${clicYear} at 12:00pm Eastern time.  The virtual meeting will highlight the ${highlightYear} Pivot Health Short Term Medical plan performance, premiums and health care cost efforts.  To register for this event, <a class="font-weight-bold link-forum link-forum--companion" href="${urlCompanion}" target="_blank">click here</a>.  Forum attendees may submit questions in advance to: <a class="Header__contact-action Header__contact-action--email d-inline" href="mailto:forum1@healthcare.com">forum1@healthcare.com</a>.</p>
              <p class="text-center cro-info cro-info--north">The North River Insurance Company announces a public forum review of the ${highlightYear} Short Term Medical Pivot Health Plan portfolio on ${nricMonth} ${nricDay}, ${nricYear}  at 1:00pm Eastern time.  The virtual meeting will highlight the ${highlightYear} Pivot Health Short Term Medical plan performance, premiums and health care cost efforts.  To register for this event, <a class="font-weight-bold link-forum link-forum--north" href="${urlNorth}" target="_blank">click here</a>.  Forum attendees may submit questions in advance to: <a class="Header__contact-action Header__contact-action--email d-inline" href="mailto:forum2@healthcare.com">forum2@healthcare.com</a>.</p>
            </div>
          </div>
        </div>
      </div>
      `
    $('body').append(cro_modal)
    const divCountdown = document.createElement('div')
    divCountdown.id = 'cro-countdown'
    const HtmlCount = `
      <div class="countdown-wrap">
        <h3 class="title-countdown">
          <span class="title-countdown--high">Register for the Annual Indiana Public Forum Meeting on Short Term Medical Plan Performance. </br>For more information</span> <a href="#" data-toggle="modal" data-target="#cro_forum" class="cro_forum--link">click here.<a></a><span class="close">x</span>
        </h3>
      </div>
      <div id="counter-mob"></div>
      `
    divCountdown.innerHTML = HtmlCount

    const containerLpDiv = document.querySelector('main')
    if (containerLpDiv) {
      containerLpDiv.insertBefore(divCountdown, containerLpDiv.childNodes[0])
    }

    $('body').on('click', '#cro-countdown .close', function () {
      $('#cro-countdown').fadeOut('slow').addClass('d-none')
    })
  }
}

export default forumBanner
